<po-page-list
  p-title="Pedido de Compra"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
  [p-actions]="actionPage"
>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="tabelaPrincipalHeight"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-show-more-disabled]="tabelaPrincipalShowMoreDisable"
    (p-show-more)="tabelaPrincipalLoad(false)"
    p-actions-right="false"
    [p-actions]="tabelaPrincipalActions"
    (p-expanded)="loadItensPedido($event)"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  >
    <ng-template
      p-table-row-template
      let-rowItem
      let-i="rowIndex"
      p-tooltip="Detalhes"
      [p-table-row-template-arrow-direction]="'left'"
      [p-table-row-template-show]="showDetalhes"
    >
      <po-table class="po-sm-12 po-md-12 po-lg-12"
        [p-sort]="true"
        p-container
        p-spacing="small"
        [p-striped]="true"
        [p-columns]="tabelaPedidoCompraColumns"
        [p-items]="rowItem.items"
        p-hide-columns-manager="false"
        [p-height]="300"
      ></po-table>
    </ng-template>

  </po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-input class="po-sm-12 po-md-4 po-lg-4"
      name="CC7NUM"
      p-label="Código"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC7NUM"
      p-clean="true"
    ></po-input>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC7EMISSAO_DE"
      p-label="Emissão de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC7EMISSAO_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC7EMISSAO_ATE"
      p-label="Emissão até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC7EMISSAO_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC7DATPRF_DE"
      p-label="Necessidade de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC7DATPRF_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC7DATPRF_ATE"
      p-label="Necessidade até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC7DATPRF_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
      p-label="Usuário Solicitante"
      name="CC7USER"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC7USER"
      p-field-label="CUSRNOME"
      p-field-value="CUSRID"
      [p-columns]="usuarioColumnsFilters"
      [p-field-format]="usuarioLookupService.getFieldFormater"
      [p-filter-service]="usuarioLookupService"
      [p-advanced-filters]="usuarioLookupService.getAdvancedFilter()"
      [p-literals]="{ modalTitle: 'Usuário' }"
    ></po-lookup>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
      p-label="Fornecedor"
      name="CC7FORNECELOJA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC7FORNECELOJA"
      p-field-label="CA2NREDUZ"
      p-field-value="CA2CODLOJA"
      [p-columns]="fornecedorColumnsFilters"
      [p-field-format]="fornecedorLookupService.getFieldFormater"
      [p-filter-service]="fornecedorLookupService"
      [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
      [p-literals]="{ modalTitle: 'Fornecedor' }"
    ></po-lookup>
    <po-select class="po-sm-12 po-md-4 po-lg-4"
      name="pageSize"
      p-label="Paginação"
      [(ngModel)]="tabelaPrincipalFiltro.dados.pageSize"
      [p-options]="tabelaPrincipalFiltro.listaPaginacao"
      [p-required]="true"
    ></po-select>
  </form>
</po-modal>

<po-modal #enviarEmailFornecedorModal p-title="Enviar Email Fornecedor #{{pcEnviarEmailFornecedor.CC7NUM}}">
  <po-textarea class="po-sm-12 po-md-12 po-lg-12"
    name="COBSERVACAO"
    p-label="Observação"
    [(ngModel)]="pcEnviarEmailFornecedor.COBSERVACAO"
    p-clean="true"
  ></po-textarea>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Enviar Email"
      p-icon="po-icon-ok"
      (p-click)="enviarEmailFornecedor()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="enviarEmailFornecedorModal.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>
